module.exports = __webpack_public_path__ + "img/donate_icon.599a7111.svg";